// extracted by mini-css-extract-plugin
export default {"progressNoteSectionRow":"ProgressNoteSection_progressNoteSectionRow__S3xTp","textArea":"ProgressNoteSection_textArea__Mkyfm"};